import { useState } from "react";
import { Sparkle, DownloadSimple, ArrowRight, X, Crown } from "@phosphor-icons/react";
import WelcomeModal from "./WelcomeModal";

/**
 * WelcomeBanner — sticky banner shown on the Dashboard for EVOLUTION/ELITE
 * users. Opens WelcomeModal on click. Never triggers auto-confetti (that's
 * reserved for the first-time modal).
 *
 * Props:
 *   plan: "evolution" | "elite"
 *   userName: string
 *   onDismiss: () => void   // permanent dismiss (marks welcome_seen)
 */
export default function WelcomeBanner({ plan, userName, onDismiss }) {
  const [open, setOpen] = useState(false);
  const isElite = plan === "elite";
  const firstName = (userName || "Atleta").split(" ")[0];

  return (
    <>
      <div
        className="relative bg-gradient-to-r from-as-green/20 via-as-green/10 to-transparent border border-as-green/40 p-4 sm:p-5 mb-8"
        data-testid="welcome-banner"
      >
        <button
          onClick={onDismiss}
          className="absolute top-2 right-2 w-7 h-7 flex items-center justify-center text-as-gray hover:text-white"
          aria-label="Ocultar"
          data-testid="welcome-banner-dismiss"
        >
          <X size={14} weight="bold" />
        </button>
        <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
          <div className="w-12 h-12 rounded-full bg-as-green flex items-center justify-center flex-shrink-0">
            {isElite ? (
              <Crown size={22} weight="fill" color="#0d0d0d" />
            ) : (
              <Sparkle size={22} weight="fill" color="#0d0d0d" />
            )}
          </div>
          <div className="flex-1 min-w-0 pr-6">
            <p className="as-label text-as-green mb-1">
              {isElite ? "BIENVENIDO A AS ELITE" : "BIENVENIDO A AS EVOLUTION"}
            </p>
            <h3 className="text-white font-bold text-lg sm:text-xl leading-tight">
              {firstName}, tu Pack de Bienvenida está listo.
            </h3>
            <p className="text-as-gray text-xs sm:text-sm mt-1">
              Descárgalo, imprímelo y arranca hoy tu transformación.
            </p>
          </div>
          <button
            onClick={() => setOpen(true)}
            className="inline-flex items-center gap-2 bg-as-green text-as-black font-bold text-xs uppercase tracking-widest px-5 py-3 hover:bg-white transition-colors whitespace-nowrap"
            data-testid="welcome-banner-cta"
          >
            <DownloadSimple size={14} weight="bold" />
            Abrir mi pack
            <ArrowRight size={12} weight="bold" />
          </button>
        </div>
      </div>

      <WelcomeModal
        open={open}
        onClose={() => setOpen(false)}
        autoConfetti={false}
      />
    </>
  );
}
